import { render, staticRenderFns } from "./IncomingStock.vue?vue&type=template&id=606c9723&scoped=true"
import script from "./IncomingStock.vue?vue&type=script&lang=js"
export * from "./IncomingStock.vue?vue&type=script&lang=js"
import style0 from "./IncomingStock.vue?vue&type=style&index=0&id=606c9723&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "606c9723",
  null
  
)

export default component.exports